var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"wrapper"},[_vm._m(0),_c('subscription'),_c('div',{staticClass:"section-split"},[_c('discord'),_c('creditcard')],1),_c('div',{staticClass:"section-split"},[_c('password'),_c('email')],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Account Settings")]),_c('p',[_vm._v("Manage your subscription, personal information and access chat room.")])])
}]

export { render, staticRenderFns }